import 'css-chunk:src/app/containers/Home/ApplicationsView/ApplicationDetailView/ApplicationDetails.scss';export default {
  "ApplicationDetails": "_ApplicationDetails_lzo55_1"
};